import React, { Suspense } from 'react';
import moment from 'moment';
import { useLazyLoadQuery } from 'react-relay/hooks';
import { graphql } from 'babel-plugin-relay/macro';
import { get } from 'lodash';
import { ErrorBoundary } from 'core';

import { QuestionCopayBillingCopayIdQuery } from './__generated__/QuestionCopayBillingCopayIdQuery.graphql';
import QuestionCopay from './QuestionCopay';
import { TBillingData } from './QuestionCopayExternalIdQuery';

interface Props {
  patientFormId?: string;
  billingCopayId?: string;
  questionTextHTML: string;
}

const QuestionCopayWrapper = (props: Props) => {
  const { billingTransactionOne } = useLazyLoadQuery<QuestionCopayBillingCopayIdQuery>(
    graphql`
      query QuestionCopayBillingCopayIdQuery($id: MongoID!, $billingCopayId: MongoID!) {
        billingTransactionOne(filter: { patientForm: $id, billingCopay: $billingCopayId }) {
          _id
          amount
          externalId {
            source
            value
          }
          externalLink
          createdAt
          status
          billingCopay {
            name
          }
        }
      }
    `,
    { id: props.patientFormId!, billingCopayId: props.billingCopayId! },
    {
      fetchPolicy: 'network-only',
    },
  );

  const getFormattedDate = (createdAt: any) => moment.utc(createdAt).format('M/D/YYYY, h:mm:ss A UTC');
  const getFormattedAmount = (amount: any) => (amount / 100).toFixed(2);

  const billingData: TBillingData = {
    name: get(billingTransactionOne, 'billingCopay.name', ''),
    transactionId: get(billingTransactionOne, '_id', ''),
    date: getFormattedDate(get(billingTransactionOne, 'createdAt', '')),
    amount: `$${getFormattedAmount(get(billingTransactionOne, 'amount', 0))}`,
    vendor: get(billingTransactionOne, 'externalId.source', ''),
    vendorTransactionId: get(billingTransactionOne, 'externalId.value', ''),
    transactionLink: get(billingTransactionOne, 'externalLink', '') ?? '',
    status: get(billingTransactionOne, 'status', '') ?? '',
  };

  return (
    <>
      {billingTransactionOne && <QuestionCopay billingData={billingData} questionTextHTML={props.questionTextHTML} />}
    </>
  );
};

export default (props: Props) => (
  <ErrorBoundary>
    <Suspense fallback={null}>
      <QuestionCopayWrapper {...props} />
    </Suspense>
  </ErrorBoundary>
);
